import { Badge, Col, Grid, Row, Typography } from "@visa/vds";
import React from "react";

const VstsAccessStatus = (props) => {
    return (
        <Grid className="vsts-status" name="vstsAccessStatus">
            <Row>
                <Typography style={{marginRight: "5px"}}>VSTS ACCESS:</Typography>
                <Typography className={`vstsAccessText vstsAccessDescription${props.vstsAccessDescriptionNo}`}>{props.vstsAccess == true ? "ACTIVE " : "INACTIVE "}</Typography>
                <Typography className={`vstsAccessDescription${props.vstsAccessDescriptionNo}`}>{props.vstsAccessDescription.toUpperCase()}</Typography>
            </Row>
        </Grid>
    )
}

export default VstsAccessStatus;